import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _isEmpty from "lodash/isEmpty";
import _toUpper from "lodash/toUpper";

var _templateObject;

import React from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import { Type } from '@nerdwallet/currency';
import { gql, useQuery } from '@nerdwallet/apollo';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import MarketplaceSearch from '../marketplace-search';
import styles from "./index.module.css";
import { PLACEHOLDER, getErrorMessage, OFFER_FIELD, NAMED_QUERY } from '../lib/product-constants';

var renderSuggestion = function renderSuggestion(suggestion) {
  return /*#__PURE__*/React.createElement("div", {
    className: ClassNames(styles.suggestionWrapper)
  }, /*#__PURE__*/React.createElement(Type, {
    className: styles.suggestionText,
    dangerouslySetInnerHTML: {
      __html: suggestion.displayName
    }
  }));
};

export var GET_AUTOCOMPLETE_SEARCH = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query marketplaceAutocompleteData(\n    $isFuzzy: Boolean\n    $keyword: String!\n    $namedQuery: String\n    $limit: Int\n    $productType: String!\n    $queryFields: [String!]\n    $sort: String\n  ) {\n    marketplaceAutocompleteSearch(\n      isFuzzy: $isFuzzy\n      keyword: $keyword\n      namedQuery: $namedQuery\n      limit: $limit\n      productType: $productType\n      queryFields: $queryFields\n      sort: $sort\n    ) {\n      ... on MarketplaceEntityInterface {\n        id\n      }\n      ... on MarketplaceEntityWithPlacementInterface {\n        displayName\n      }\n    }\n  }\n"])));

var PersonalLoansSearch = function PersonalLoansSearch(_ref) {
  var analytics = _ref.analytics,
      defaultValue = _ref.defaultValue,
      label = _ref.label,
      onSelectHandler = _ref.onSelectHandler,
      placeholder = _ref.placeholder;

  var _React$useState = React.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var productType = PRODUCT_TYPES.PERSONAL_LOANS;
  var queryVariables = {
    isFuzzy: true,
    keyword: value,
    namedQuery: NAMED_QUERY.PERSONAL_LOANS,
    productType: _toUpper(productType),
    queryFields: [OFFER_FIELD.NAME, OFFER_FIELD.PRODUCT_NAME, OFFER_FIELD.PRODUCT_INSTITUTION_NAME],
    // offer.name is the most descriptive name compared to offer.product.name and offer.product.institution.name
    sort: OFFER_FIELD.NAME
  };

  var _useQuery = useQuery(GET_AUTOCOMPLETE_SEARCH, {
    variables: queryVariables,
    skip: _isEmpty(value),
    fetchPolicy: 'no-cache'
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data,
      refetch = _useQuery.refetch;

  var suggestions = data === null || data === void 0 ? void 0 : data.marketplaceAutocompleteSearch;

  var hasError = !!error || !loading && !_isEmpty(value) && _isEmpty(suggestions);

  return /*#__PURE__*/React.createElement(MarketplaceSearch, {
    analytics: analytics,
    error: hasError,
    errorMessage: getErrorMessage(value, productType),
    id: "personal-loans-search",
    label: label,
    onSelectHandler: onSelectHandler,
    placeholder: placeholder,
    productType: productType,
    queryVariables: queryVariables,
    refetch: refetch,
    renderSuggestion: renderSuggestion,
    setValue: setValue,
    suggestions: suggestions,
    value: value
  });
};

PersonalLoansSearch.displayName = 'PersonalLoansSearch';
PersonalLoansSearch.propTypes = {
  /**
   * analytics properties
   */
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    formName: PropTypes.string,
    sectionName: PropTypes.string,
    sectionPosition: PropTypes.number
  }),

  /**
   * Optional to set default value of the input.
   */
  defaultValue: PropTypes.string,

  /**
   * The description displayed above the input.
   */
  label: PropTypes.string || PropTypes.node,

  /**
   * A onclick handler that gives access to the selected suggestion.
   * Passed to the base component.
   */
  onSelectHandler: PropTypes.func.isRequired,

  /**
   * The text displayed inside the input when no value is entered.
   */
  placeholder: PropTypes.string
};
PersonalLoansSearch.defaultProps = {
  defaultValue: '',
  label: '',
  placeholder: PLACEHOLDER.PERSONAL_LOANS
};
export default PersonalLoansSearch;